import type {
    JSX,
} from "preact";
import {
    forwardRef,
} from "preact/compat";

type StatusDotStatus = "healthy" | "unhealthy" | "unknown" | "pending";

type StatusDotProps = Omit<JSX.HTMLAttributes<HTMLSpanElement>, "children"> & {
    status?: StatusDotStatus;
    pulse?: boolean;
};

const statusStyles: Record<StatusDotStatus, string> = {
    healthy: "bg-success",
    unhealthy: "bg-error",
    unknown: "bg-text-muted",
    pending: "bg-warning",
};

export const StatusDot = forwardRef<HTMLSpanElement, StatusDotProps>(
    ({
        status = "unknown",
        pulse = false,
        className = "",
        ...props
    }, ref) => {
        return (
            <span
                ref={ref}
                className={`inline-block w-2.5 h-2.5 rounded-full ${
                    statusStyles[status]
                } ${pulse ? "animate-pulse" : ""} ${className}`}
                aria-label={status}
                {...props}
            />
        );
    },
);
